module.exports = function isInteger(obj){return !isNaN(obj) && parseInt(obj) == obj;};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isInteger.js
 ** module id = 17
 ** module chunks = 0
 **/